import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Typography } from "@mui/material";

// Icon Animation on Hover
const HoverGifIcon = ({ staticSrc, gifSrc, alt, active }) => {
  return (
    <img
      src={active ? gifSrc : staticSrc}
      alt={alt}
      style={{
        width: 42,
        height: 42,
        objectFit: "contain",
        transform: active ? "scale(1)" : "scale(1)",
        transition: "transform 0.15s ease-out",
        pointerEvents: "none",
        backgroundColor: "#F5F5F5",
      }}
    />
  );
};

function JewelMasterDashboard() {
  const [hoveredKey, setHoveredKey] = useState(null);

  const navigate = useNavigate();
  const loggedUser = JSON.parse(localStorage.getItem("CapacitorStorage.user"));
  const user_id = loggedUser.id;
  const user_mobile = loggedUser.mobile;
  const store_id = loggedUser.store_id;
  const userDataObject = {
    user_id,
    user_mobile,
    store_id,
  };

  const pageRoutes = [
    {
      label: "Metal Type Master",
      screenRoute: "/jewel-master/metal-type-master",
      icon: (hovered) => (
        <HoverGifIcon
          staticSrc={require("../../assets/icons/metal-type-master.png")}
          gifSrc={require("../../assets/icons/metal-type-master.gif")}
          active={hovered}
        />
      ),
      key: "metal-type-master",
    },
    {
      label: "Purity Master",
      screenRoute: "/jewel-master/purity-master",
      icon: (hovered) => (
        <HoverGifIcon
          staticSrc={require("../../assets/icons/purity-master.png")}
          gifSrc={require("../../assets/icons/purity-master.gif")}
          active={hovered}
        />
      ),
      key: "purity-master",
    },
    // {
    //   label: "Item Type Master",
    //   screenRoute: "/jewel-master/item-type-master",
    //   icon: (hovered) => (
    //     <HoverGifIcon
    //       staticSrc={require("../../assets/icons/item-type-master.png")}
    //       gifSrc={require("../../assets/icons/item-type-master.gif")}
    //       active={hovered}
    //     />
    //   ),
    //   key: "item-type-master",
    // },
    // {
    //   label: "Rate Master",
    //   screenRoute: "/jewel-master/rate-master",
    //   icon: (hovered) => (
    //     <HoverGifIcon
    //       staticSrc={require("../../assets/icons/rate-master.png")}
    //       gifSrc={require("../../assets/icons/rate-master.gif")}
    //       active={hovered}
    //     />
    //   ),
    //   key: "rate-master",
    // },
  ];

  return (
    <>
      {/* MAIN CONTENT */}
      <Box
        sx={{
          height: "100%",
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          overflow: "hidden",
          animation: "fadeIn 0.4s ease",
        }}
      >
        <Box
          sx={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
            gap: 2,
          }}
        >
          {pageRoutes.map((page) => {
            const isHovered = hoveredKey === page.key;

            return (
              <Box
                key={page.key}
                onMouseEnter={() => setHoveredKey(page.key)}
                onMouseLeave={() => setHoveredKey(null)}
                onClick={() =>
                  navigate(page.screenRoute, { state: userDataObject })
                }
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                  gap: 0.5,
                  // px: 1,
                  py: 1,
                }}
              >
                <Box
                  sx={{
                    width: 64,
                    height: 64,
                    borderRadius: 2,
                    bgcolor: "#F5F5F5",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {page.icon(isHovered)}
                </Box>

                <Typography
                  sx={{
                    textAlign: "center",
                    fontSize: 14,
                    fontWeight: 600,
                    transform: isHovered ? "scale(0.9)" : "scale(1)",
                    transition: "transform 0.2s ease",
                  }}
                >
                  {page.label}
                </Typography>
              </Box>
            );
          })}
        </Box>
      </Box>

      <style>
        {`
            @keyframes fadeIn {
              from { opacity: 0; transform: translateY(6px); }
              to { opacity: 1; transform: translateY(0); }
            }
          `}
      </style>
    </>
  );
}

export default JewelMasterDashboard;
